import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import WindowSvg from '../../../../themes/svg/window.svg';

const productLineImages = {
  1: WindowSvg,
};

const EmptyProduct = ({
  buttonText,
  productLine,
  itemId,
  selectProductForItem,
  getPLPUrl,
  windowCategoryMappings,
  designId,
}) => {
  const navigate = useCallback((e) => {
    e.preventDefault();
    selectProductForItem(itemId);
  }, [itemId]);
  const href = useMemo(() => `${getPLPUrl(itemId)}`, [itemId, designId, windowCategoryMappings]);

  const ProductLineImage = useMemo(() => productLineImages[productLine], [productLine]);

  return (
    <div className="itemProduct">
      <div className="emptyProduct">
        {<ProductLineImage className="windowImage" /> }
        <div className="addProduct">
          <a
            className="btn btn-secondary"
            href={href}
            onClick={navigate}
          >
            {buttonText}
          </a>
        </div>
      </div>
    </div>
  );
};
EmptyProduct.propTypes = {
  buttonText: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  selectProductForItem: PropTypes.func.isRequired,
  getPLPUrl: PropTypes.func.isRequired,
  windowCategoryMappings: PropTypes.shape({}).isRequired,
  productLine: PropTypes.number,
  designId: PropTypes.string,
};
EmptyProduct.defaultProps = {
  productLine: undefined,
  designId: '',
};

export default EmptyProduct;
